import { render } from "./Cookies.vue?vue&type=template&id=aa583a4e&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=aa583a4e&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=aa583a4e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1098539037/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa583a4e"]])

export default __exports__